import moment from "moment";

/** Calculate total and quantity for the different rate types
 * 1 CPM:  rate/1000.
 * 4 CPD:  total = rate * qty, qty = # of days
 * 5 Flat Fee going to Ad Manager:  total = rate, qty = # of days
 * 5 Flat Fee (not Ad Manager): total = rate, qty = 1
 * 6 CPV:  rate * qty
 * 2,3 CPA/CPC: no data to calculate, do rate * qty
 */
export const computeTotalContractAmount = (qty, rate, rateType, start, end, lineItemType) => {
  let total;
  let quantity = qty;
  // API / DECIMAL payloads can yield string ids; coerce so === checks work.
  const typeId = Number(rateType);
  if (typeId === 1) {
    const tca = qty * rate / 1000;
    total = Math.round(tca * 100) / 100;
  } else if (typeId === 4 || (typeId === 5 && lineItemType !== 'NOT AD MANAGER')) {
    if (start && end) {
      const start1 = moment(start).startOf('day');
      const end1 = moment(end).startOf('day');
      quantity = moment(end1).diff(moment(start1), 'days') + 1;
      total = (typeId === 4) ? rate * quantity : rate;
    } else {
      total = 0;
      quantity = 0;
    }
  } else if (typeId === 5) {
    total = rate;
  } else {
    total = Math.round(qty * rate * 100) / 100;
  }
  return { total, quantity }
};

/** Whether contractedQuantity is derived from flight dates (not impressions). */
export const quantityDerivedFromDates = (rateType, lineItemType) => {
  const typeId = Number(rateType);
  return typeId === 4 || (typeId === 5 && lineItemType !== 'NOT AD MANAGER');
};
